import { Pipe, PipeTransform } from '@angular/core';
import { CreditCardType } from '@platform-frontend/payment-util';
import { IconName } from '@platform-frontend/ui-tools';

@Pipe({
  name: 'cardTypeIcon'
})
export class CardTypeIconPipe implements PipeTransform {
  transform(value: CreditCardType | 'INVALID' | null): IconName {
    switch (value) {
      case 'MasterCard':
        return 'mastercard-branded';
      case 'Visa':
        return 'visa-branded';
      case 'AmericanExpress':
        return 'amex-branded';
      case 'INVALID':
        return 'credit-card-validator-error';
      default:
        return 'credit-card-validator-neutral';
    }
  }
}
